import axios from "axios";
import { useEffect, useState } from "react";
import BaseUrl from "../BaseUrl";

export default function ListLocation() {
const [locdata,setLocData]=useState([])
  
function getAllLocation(){
    axios
    .get(`${BaseUrl.baseurl}/dummy/get-all-location`)
    .then((res) => {
        if(res.data.status){
            setLocData(res.data.details)
        }
        else
        {
            setLocData([])
        }
       
    })
    .catch((err) => console.log("Error"));
}
useEffect(()=>{
    getAllLocation()
},[])
function deleteLocation(id){
    axios
    .delete(`${BaseUrl.baseurl}/dummy/delete-location-id/${id}`)
    .then((res) => {
        if(res.data.status){
            getAllLocation()
        }
       
       
    })
    .catch((err) => console.log("Error"));
}
  return (
    <div className="login-parent-container md:grid md:grid-cols-2 md:gap-4">
     <table className="styled-table">
        <thead>
           <tr>
           <th>Latitude</th>
            <th>Longitude</th>
            <th>Place</th>
            <th>Action</th>
           </tr>
        </thead>
        <tbody>
            {locdata.map((val)=>{
                return(
                    <tr>
                    <td>{val.Lat}</td>
                    <td>{val.Long}</td>
                    <td>{val.Place}</td>
                    <td>
                <button onClick={() => {deleteLocation(val._id)}}>Delete</button>
              </td>
                </tr>
                )
            })}
           
        </tbody>
     </table>
    </div>
  );
}
